import { useState,useEffect } from "react";
import { useDispatch,useSelector } from "react-redux";
import reload from "../../assets/icons/reload.svg";
import CustomTabsV2 from "../universal/CustomTabsV2";
import CollapsibleRightPanel from "../universal/CollapsibleRightPanel";
import {AddChurchHooks}  from "../../screens/Bulletin/hooks/BulletinHooks";
import { AllChurchHooks } from "../../screens/Bulletin/hooks/BulletinHooks";
import DropdownWithTags from "../universal/DropdownWithTags";
import LayoutDropdown from "../universal/LayoutDropdown";
import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import edit from "../../assets/icons/edit.svg";
import close from "../../assets/icons/close.svg";
import LanguageDrawer from "../universal/LanguageDrawer";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import GalleryVideoField from "../../components/videoGallery/GalleryPickerField"
import GalleryPickerField from "../../components/ImageGallery/GalleryPickerField"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactQuill from "react-quill";
import { toast } from "react-toastify";
const AddVideosFields = ({ setLoading, data,rowData,onClose ,church}) => {
  // const { options } = GetRelatedVideosHooks();
  const dispatch = useDispatch();

   const {
    activeTab,
    activeLanguageDetails,
    setActiveLanguageDetails,
    setActiveTab,
    handleInputChange,
    handleFileInputChange,
    handleSave,
    readLanguageData,
    videoInputs,

    videoErrors,
    videoUrlsInputs,
    showVideoLibraryModal,
    setShowVideoLibraryModal,
    setVideoUrlsInputs,
    setDownloadUrlsInputs,
    setTumbNailUrlsInputs,
    setImageSet,
    tumbNailUrlsInputs,
    UdownloadrlsInputs,
    handleChange,
    selectedOptions,
    setSelectedOptions,
    deleteRelatedVideo,
    setSelectedRelatedVideoIndex,
    handleDropdownChange,
    setLayoutValues,
    handleVideoLayoutChange,
    layoutValues,
    initialLayoutValues,
    setLayoutInfo,
    layoutInfo,
    handleDateChange,
    handleAddLayoutToArray,
    layoutArray,
    setAddedLayout,
    addedLayout,
    handleVideoDateChange,
    options,
    handleDeleteLayoutFromArray,
    setIsLayoutEdit,
    isLayoutEdit,
    setEditLayoutIndex,
    setEditTargetLayout,
    editTargetLayout,
    handleLayoutUpdate,
    updateStateWithTranslation,
    handleCommonTumbNailInputChange,
    setCommonUrlsInputs,
    commonVideoUrlsInputs,
    previewUrlsInputs,
    setPreviewUrlsInputs,
    languagemeta,
    setIsLanguageSave,
    handleSaveLanguage,
    handleLibraryVideoSelection,
    handleSendNotification,
    handleUpdateChurch,
    handleCarecellChange,
    handleSaveCarecellCoverImage,
    churchInputs, setChurchInputs,
    thumbnailImage, setThumbnailImage,
    isLive,setIslive,
    isDefault,setIsDefault
  } = AddChurchHooks(setLoading, data);

  const [showModal, setShowModal] = useState(false);
  const [isImage, setIsImage] = useState(false);
  const [currentUrl, setCurrentUrl] = useState("");
  const [selectedLocation, setSelectedLocation] = useState({
    lat: "",
    lng: "",
    address: ""
  });

const handleGallerySelect = (imageSet) => {
    setImageSet(imageSet)
  setTumbNailUrlsInputs({
    webUploadUrl: imageSet?.target?.value?.web?.url || "",
    tabletUploadUrl: imageSet?.target?.value?.tablet?.url || "",
    mobileUploadUrl: imageSet?.target?.value?.mobile?.url || "",
  });
};
const [selectedDate, setSelectedDate] = useState(null);
const [isOpen, setIsOpen] = useState(false);

const SelectDateChange = (date) => {
  setSelectedDate(date);
  setIsOpen(false); // close picker after selection
};
const [bulletinDesc, setBulletinDesc] = useState(rowData?.bulletindesc || "");
const [bulletinNotes, setBulletinNotes] = useState(rowData?.bulletinNotes || "");



const handleThumbSelect = (img) => {
    setThumbnailImage(img?.target?.value?.[0]?.id);
};
const isQuillEmpty = (value) => {
  const div = document.createElement("div");
  div.innerHTML = value || "";
  return !div.textContent?.trim();
};
const validateBulletinFields = () => {
  if (!church) {
    toast.error("Church is required");
    return false;
  }

  if (!churchInputs?.bullitinTitle?.trim()) {
    toast.error("Bulletin Title is required");
    return false;
  }

  if (!churchInputs?.bullitinDate) {
    toast.error("Bulletin Date is required");
    return false;
  }


  if (!selectedDate) {
    toast.error("Bulletin Date is required");
    return false;
  }



  return true;
};
const [apiBulletin, setApiBulletin] = useState(null);
      const { fetchAllChurches } = AllChurchHooks();

useEffect(() => {
  if (!rowData?.bulletinObjId || !church?._id) return;

  fetchAllChurches(
    1,
    100,
    {},
    (res) => {
      if (!res?.data?.length) return;

      const bulletin = res.data.find(
        (b) => b.bulletinObjId === rowData.bulletinObjId
      );

      if (bulletin) {
        setApiBulletin(bulletin);
      }
    },
    church._id
  );
}, [rowData?.bulletinObjId, church?._id]);
useEffect(() => {
  if (!apiBulletin) return;

  // 🔹 Language meta


  setChurchInputs((prev) => ({
    ...prev,
    bullitinTitle: apiBulletin.bullitinTitle || "",
    bullitinDate: apiBulletin.bullitinDate || "",
    bulletinNotes: apiBulletin.bulletinNotes || "",
    bulletinDownloadUrl: apiBulletin.bulletinDownloadUrl || "",
  }));

  // 🔹 Date picker sync
  if (apiBulletin?.bullitinDate) {
    setSelectedDate(new Date(apiBulletin.bullitinDate));
  }
}, [apiBulletin]);
const cleanHtmlContent = (htmlContent) => {
  if (!htmlContent) return htmlContent;

  // Remove ALL color-related styles and formatting
  return htmlContent
    // Remove background-color styles
    .replace(/style="[^"]*background-color[^;"]*;?[^"]*"/gi, '')
    // Remove color styles
    .replace(/style="[^"]*color:[^;"]*;?[^"]*"/gi, '')
    // Remove any style attribute that contains color (more comprehensive)
    .replace(/style="[^"]*(color|background|background-color)[^"]*"/gi, '')
    // Remove any style attributes with single quotes
    .replace(/style='[^']*'/gi, '')
    // Remove empty style attributes
    .replace(/style=""/gi, '')
    // Remove any span tags that might have had styling (keeps span but removes all styles)
    .replace(/<span[^>]*>/gi, '<span>')
    // Remove any font tags that might bring color
    .replace(/<font[^>]*>/gi, '')
    .replace(/<\/font>/gi, '')
    // Also remove any color-related CSS classes
    .replace(/class="[^"]*color[^"]*"/gi, '');
};
  return (
    <div className="flex flex-col md:flex-row h-full w-full flex-1 rounded-2xl overflow-hidden">
      <div className="flex h-full flex-1">
        <LanguageDrawer
          languageData={readLanguageData}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          setActiveLanguageDetails={setActiveLanguageDetails}
          languagemeta={languagemeta}
          setIsLanguageSave={setIsLanguageSave}
        />
        <div className="flex h-full flex-1">
          <div className="flex flex-col h-full w-full bg-greyishV2 bg-opacity-50 md:border-l md:border-r border-greyish border-opacity-30 overflow-auto">
            <div className="flex gap-4 items-center justify-between h-[64px] px-4 border-b border-[#28292a]">
              <p className="text-white font-semibold text-lg">
                {activeTab === "en"
                  ? "Add Bulletin"
                  : `Translate Churche to ${activeLanguageDetails?.language_name}`}
              </p>
              <div className="flex items-center gap-5">
                {activeTab !== "en" && data?._id && (
                  <p
                    className="flex items-center gap-1 text-greyish text-[11px] font-medium cursor-pointer whitespace-nowrap"
                    onClick={updateStateWithTranslation}
                  >
                    <img src={reload} alt="" /> Auto fill data with google translation
                  </p>
                )}
                {data?._id && (
                  <button
                    className="text-yellowish bg-blackish font-medium text-[12px] whitespace-nowrap border border-yellowish rounded-xl py-2 px-6"
                    onClick={handleSendNotification}
                  >
                    Send Notification
                  </button>
                )}
                {activeTab === "en" ? (
                  <div className="w-full flex items-end justify-end gap-4">
                    {/* <button
                      className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                      onClick={handleSave}
                    >
                      {rowData?._id ? "Update Church" : "Save Church"}
                    </button> */}
                    {
                      rowData?.bulletinObjId ?
                      <button
                      className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                      // onClick={() => handleUpdateChurch(rowData)}
                      onClick={async () => {
                        try {
                          await handleUpdateChurch(rowData)// wait until API completes and toast appears
                          onClose();          // now close the modal
                        } catch (err) {
                                                    // optionally keep modal open or close anyway
                        }
                      }}
                    >Update Bulletin</button>
                    :
                    <button
                    className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                    onClick={async () => {
                      if (!validateBulletinFields()) return;

                      try {
                        await handleSave(church._id);
                        onClose();
                      } catch (err) {
                                              }
                    }}

                  >Save Bulletin</button>
                    }
                  </div>
                ) : data?._id ? (
                  <div className="w-full flex items-end justify-end gap-4">
                    <button
                      className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                      onClick={handleSaveLanguage}
                    >
                      Save Language
                    </button>
                  </div>
                ) : null}
              </div>
            </div>
            {/* TAB CONTENT  */}
            {activeTab !== "en" && !data?._id ? (
              <div className="flex items-center justify-center text-white gap-1 py-28">
                Church translation in{" "}
                <span className="italic">{activeLanguageDetails?.language_name}</span> is available
                for saved churches
              </div>
            ) : (
              <div className="px-4 my-4 h-full">
              <div className="overflow-y-auto overflow-x-hidden px-2">
              <div className="grid md:grid-cols-2 grid-cols-1 gap-4 mx-1 w-full">
  {/* Name */}
  <div className="md:col-span-2 col-span-1 relative">
  <label className="text-[12px] text-greyish font-medium leading-4 flex items-center gap-2">
    Church *
  </label>

  <input
    type="text"
    name="church_id"
    placeholder="Enter Church Name"
    className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
    value={church ? church.churchName : ""}

    readOnly
  />

  {videoErrors?.church_id && (
    <p className="text-red-500 relative bottom-[-6px] text-[10px] left-2">
      Church selection is required
    </p>
  )}
</div>


  {/* _id (hidden or read-only) */}
  <input
    type="hidden"
    name="_id"
    value={rowData?._id || ""}
  />

  {/* Church _id (hidden or read-only) */}
  <input
    type="hidden"
    name="church_id"
    value={rowData?.church_id || ""}
  />
  <div className="md:col-span-2 col-span-1">
    <label className="text-[12px] text-greyish font-medium leading-4">
      Bulletin Title *
    </label>
    <input
      name="bullitinTitle"
      placeholder="Enter Bulletin Title"
      type="text"
      className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
      defaultValue={churchInputs?.bullitinTitle || ""}
      onChange={handleChange}
    />
    {videoErrors?.programName && (
      <p className="text-red-500 relative bottom-[-6px] text-[10px] left-2">
        Bulletin Name is required
      </p>
    )}
  </div>
  <div className="relative w-full">
      {/* Input that opens DatePicker */}
      <label className="text-[12px] text-greyish font-medium leading-4">
      Bulletin Date *
    </label>
      <input
        type="text"
        name="bullitinDate"
        readOnly
        placeholder="Select Date"
        value={selectedDate ? selectedDate.toLocaleDateString() : ""}
        onClick={() => setIsOpen(!isOpen)}
        className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10 cursor-pointer"
      />

      {/* DatePicker (hidden until opened) */}
      {isOpen && (
        <div className="absolute z-50 mt-2">
       <DatePicker
  selected={selectedDate}
  onChange={(date) => {
    setSelectedDate(date);
    handleChange({
      target: {
        name: "bullitinDate",
        value: date ? date.toISOString() : "",
      },
    });
    setIsOpen(false);
  }}
  inline
/>

        </div>
      )}
    </div>
  {/* bulletinNotes */}
  {/* <div className="md:col-span-2 col-span-1">
        <label className="text-[12px] text-greyish font-medium leading-4">
          Bulletin Description
        </label>
        <div className="mt-2">
          <ReactQuill
            theme="snow"
            value={bulletinDesc}
            onChange={(value) => {
              setBulletinDesc(value);
              handleChange({ target: { name: "bulletindesc", value } });
            }}
            placeholder="Enter Bulletin Description"
            className="text-white text-[14px] font-medium rounded-md bg-blackish quill-custom"
          />
        </div>
        {videoErrors?.bulletindesc && (
          <p className="text-red-500 text-[10px] left-2">
            Bulletin Description is required
          </p>
        )}
      </div> */}

      {/* Bulletin Notes */}
      <div className="md:col-span-2 col-span-1">
  <label className="text-[12px] text-greyish font-medium leading-4">
    Bulletin Notes
  </label>
  <div className="mt-2">
    <ReactQuill
      theme="snow"
      value={churchInputs?.bulletinNotes}
      onChange={(value) => {
        const cleanedValue = cleanHtmlContent(value); // Clean the HTML content
        setBulletinNotes(cleanedValue);
        handleChange({ target: { name: "bulletinNotes", value: cleanedValue } });
      }}
      placeholder="Enter Bulletin Notes"
      className="text-white text-[14px] font-medium rounded-md bg-blackish quill-custom"
    />
  </div>
  {videoErrors?.bulletinNotes && (
    <p className="text-red-500 text-[10px] left-2">
      Bulletin Notes are required
    </p>
  )}
</div>

  {/* bulletinDownloadUrl */}
  <div className="md:col-span-2 col-span-1">
    <label className="text-[12px] text-greyish font-medium leading-4">Bulletin Download URL</label>
    <input
      name="bulletinDownloadUrl"
      placeholder="Enter Download URL"
      type="text"
      className="bg-blackish p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10"
      value={rowData?.bulletinDownloadUrl}
      onChange={handleChange}
    />
  </div>
  <div className="md:col-span-2 col-span-1">

  <GalleryPickerField
  label=" Cover Image"
  name="galleryImage"
  church={church}
  rowData={rowData}
  value={{
    web: { url: tumbNailUrlsInputs?.webUploadUrl },
    tablet: { url: tumbNailUrlsInputs?.tabletUploadUrl },
    mobile: { url: tumbNailUrlsInputs?.mobileUploadUrl },
  }}
  handleChange={handleGallerySelect}
/>
{/* <GalleryVideoField
        label="Select Video"
        name="thumbnail"
        church={church}

        handleChange={handleThumbSelect}
      />  */}
      {/* <div className="flex items-center gap-4 mt-4">
        <input
          type="checkbox"
          id="liveCheckbox"
          className="w-4 h-4 cursor-pointer accent-yellowish appearance-none border border-gray-300 rounded-full checked:bg-yellow-500 checked:border-yellow-500"
          checked={isLive}
          onChange={(e) => setIslive(e.target.checked)}
        />
        <label htmlFor="liveCheckbox" className="cursor-pointer select-none">
          Live
        </label>

        <input
          type="checkbox"
          id="defaultCheckbox"
          className="w-4 h-4 cursor-pointer accent-yellowish appearance-none border border-gray-300 rounded-full checked:bg-yellow-500 checked:border-yellow-500"
          checked={isDefault}
          onChange={(e) => setIsDefault(e.target.checked)}
        />
        <label htmlFor="defaultCheckbox" className="cursor-pointer select-none">
          Default
        </label>
      </div> */}
</div>

</div>

              </div>
            </div>
            )}
            <Tooltip id="add_church" className="border border-greyish border-opacity-20" />
          </div>
        </div>
      </div>
      <CollapsibleRightPanel title="Stats / Layouts">
        <CustomTabsV2
          tabHeight={"h-[64px]"}
          tabsTitleArray={["Stats", "Layouts"]}
          tabsContentObject={{
            Stats: (
              <div className="mt-8 flex items-center justify-center w-full text-white">
                {data?._id ? (
                  <div className="w-full px-8">
                    <p>
                      Views : <strong>{videoInputs?.totalViews}</strong>
                    </p>
                    <p>
                      Likes: <strong>{videoInputs?.totalLikes}</strong>
                    </p>
                  </div>
                ) : (
                  <>No stats available for video</>
                )}
              </div>
            ),
            Layouts: !data?._id ? (
              <div className="mt-8 flex items-center justify-center w-full text-white">
                Save this Church to assign the layout
              </div>
            ) : (
              <>
                <div className="mt-4 p-1">
                  <label htmlFor="relatedVideos" className="text-[12px] text-greyish font-medium">
                    Layouts
                  </label>
                  <div className="bg-blackish py-4 px-3 mt-3 rounded-lg">
                    <LayoutDropdown
                      setMyState={setLayoutValues}
                      setLayoutInfo={setLayoutInfo}
                      setAddedLayout={setAddedLayout}
                      addedLayout={addedLayout}
                      newTarget={editTargetLayout}
                      isLayoutEdit={isLayoutEdit}
                      outerTargetLayout={layoutValues?.layout_name}
                    />

                    {layoutInfo && (
                      <>
                        <div className="flex gap-3">
                          <div className="w-full">
                            <label
                              htmlFor="order"
                              className="text-[12px] text-greyish font-medium leading-4 "
                            >
                              Display Order
                            </label>
                            <input
                              type="text"
                              className={`bg-greyishV2 p-2 w-full text-white text-[14px] font-medium mt-2 leading-4 rounded-md h-10`}
                              name="order"
                              placeholder="Enter order"
                              value={layoutValues?.order}
                              onChange={handleVideoLayoutChange}
                            />
                          </div>
                        </div>
                        <div className="flex justify-end mt-4">
                          <div className="flex gap-3">
                            {!isLayoutEdit && (
                              <button
                                className="text-greyish bg-blackishV2 font-medium text-[12px] rounded-xl py-2 px-6"
                                onClick={() => {
                                  setLayoutValues(initialLayoutValues);
                                  setLayoutInfo(false);
                                }}
                              >
                                Cancel
                              </button>
                            )}
                            {isLayoutEdit ? (
                              <button
                                className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                                onClick={handleLayoutUpdate}
                              >
                                Confirm
                              </button>
                            ) : (
                              <button
                                className="text-yellowish bg-blackish font-medium text-[12px] border border-yellowish rounded-xl py-2 px-6"
                                onClick={handleAddLayoutToArray}
                              >
                                Add
                              </button>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
                {layoutArray?.length > 0 &&
                  activeTab === "en" &&
                  layoutArray?.map((item, index) => (
                    <div className="w-full px-4 mt-4">
                      <div className="w-full p-2 px-4 bg-black bg-opacity-10 rounded-lg border border-opacity-25 border-white">
                        <div className="flex flex-col items-center justify-center w-full text-white">
                          <div className="flex justify-between w-full">
                            <p className="text-sm font-white font-medium text-white">
                              {item?.layout_name}
                            </p>
                            <div className="flex gap-2 justify-end items-center cursor-pointer">
                              <img
                                className="h-4"
                                src={edit}
                                alt=""
                                onClick={() => {
                                  setIsLayoutEdit(true);
                                  setEditLayoutIndex(index);
                                  setLayoutValues(item);
                                  setEditTargetLayout(item?.layout_name);
                                }}
                              />
                              <img
                                className="h-4"
                                src={close}
                                alt=""
                                onClick={() => {
                                  handleDeleteLayoutFromArray(item?._id);
                                }}
                              />
                            </div>
                          </div>
                          <div className="flex justify-between w-full mt-5 bg-blackishV2 p-1 px-2">
                            <p className="text-[10px] font-white text-white">Order</p>
                          </div>
                          <div className="flex w-full mt-2 p-1 px-2">
                            <p className="flex w-full text-xs font-white font-bold text-white">
                              {item?.order}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </>
            ),
          }}
        />
      </CollapsibleRightPanel>``

    </div>
  );
};

export default AddVideosFields;
